import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const RecordIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Record button - circle with inner filled circle */}
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
      />
      {/* Inner record indicator */}
      <circle
        cx="12"
        cy="12"
        r="4"
        fill={color}
      />
    </BaseIcon>
  ),
);

RecordIcon.displayName = 'RecordIcon';
